import React from "react";
import signText from "../../json/VtrSign.json";
import { TextField } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Typography } from "@mui/material";

const SignForm3 = (props) => {
  if (props.currentStep !== 3) {
    return null;
  }

  return (
    <div className="SignForm3 margAll10" data-testid="SignForm3">
      <TextField
        label="eVTR Terms and Conditions"
        className="sign_vtr margBot20"
        fullWidth
        value={signText.signText}
        name="gearsize"
        type="text"
        variant={"outlined"}
        disabled
        multiline
        InputProps={{
          style: { fontSize: "1.25em", fontWeight: "bold" },
        }}
        InputLabelProps={{
          style: { fontSize: "1.25em", fontWeight: "bold" },
        }}
        style={{ marginTop: "25px" }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "16px",
        }}
      >
        <Typography variant="caption" display="block">
          {signText.signConnection}
        </Typography>
      </div>
      <FormControlLabel
        control={
          <Checkbox
            checked={props.isSigned}
            onChange={props.handleChange}
            color="primary"
          />
        }
        label={signText.signBoxLabel}
      />
    </div>
  );
};

export default SignForm3;
